import PropTypes from 'prop-types';
import React from 'react';

import CallItem from '../CallItem';
import { getDataByChannel } from './helpers';

const AwscCallItem = ({ call, awscCallIds, setAwscCallIds, relatedClients }) => {
  const { id, clientId, channel, initiatedAt, createdAt, agentInteractionDuration } = call;
  const { label, icon } = getDataByChannel(channel);
  const isChecked = awscCallIds.includes(id);
  const client = relatedClients.find((client) => client.id === clientId);

  const checkboxHandler = () =>
    setAwscCallIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));

  return (
    <CallItem
      id={id}
      idPrefix="awsc"
      isChecked={isChecked}
      checkboxHandler={checkboxHandler}
      icon={icon}
      label={label}
      client={client}
      callCreatedAt={initiatedAt || createdAt}
      duration={agentInteractionDuration}
    />
  );
};

AwscCallItem.propTypes = {
  call: PropTypes.object,
  awscCallIds: PropTypes.array,
  setAwscCallIds: PropTypes.func,
  relatedClients: PropTypes.array,
};

export default AwscCallItem;
